import { createAction, props } from '@ngrx/store';
import { AccessControlCandidateItemModel } from 'src/app/access-control/models/access-control-candidate-item.model';
import { AccessControlContactInformation } from 'src/app/shared/models/access-control-information.model';
import { FetchArgs, PagingTokenFixed } from 'src/app/shared/models/core';
import { ListItem } from 'src/app/shared/models/list-item.model';
import { Profession } from 'src/app/shared/models/profession.model';

export const loadAccessControlCandidates = createAction('[ACCESS CONTROL COMPONENT] Load Access Control Candidates');

export const loadAccessControlCandidatesSuccess = createAction(
    '[ACCESS CONTROL API] Load Access Control Candidates Success',
    props<{ candidates: PagingTokenFixed<AccessControlCandidateItemModel[]> }>()
);

export const loadAccessControlCandidatesFail = createAction('[ACCESS CONTROL API] Load Access Control Candidates Fail');

export const loadProfessions = createAction('[ACCESS CONTROL COMPONENT] Load Professions');

export const loadProfessionsSuccess = createAction(
    '[ACCESS CONTROL API] Load Professions Success',
    props<{ professions: Profession[] }>()
);

export const loadProfessionsFail = createAction('[ACCESS CONTROL API] Load Professions Fail');

export const setFilter = createAction('[ACCESS CONTROL COMPONENT] Set Filter', props<{ filter: FetchArgs }>());

export const loadAccessControlRecruiters = createAction(
    '[ACCESS CONTROL SUBCONTRACTOR DETAILS COMPONENT] Load Access Control Recruiters'
);

export const loadAccessControlRecruitersSuccess = createAction(
    '[ACCESS CONTROL API] Load Access Control Recruiters Success',
    props<{ recruiters: ListItem[] }>()
);

export const loadAccessControlRecruitersFail = createAction(
    '[ACCESS CONTROL API] Load Access Control Recruiters Fail',
    props<{ error: any }>()
);

export const loadAccessControlContractCompanyInformation = createAction(
    '[ACCESS CONTROL SUBCONTRACTOR DETAILS COMPONENT] Load Access Control Contract Company Information',
    props<{ candidateId: number }>()
);

export const loadAccessControlContractCompanyInformationSuccess = createAction(
    '[ACCESS CONTROL API] Load Access Control Contract Company Information Success',
    props<{ contractInformation: AccessControlContactInformation }>()
);

export const loadAccessControlContractCompanyInformationFail = createAction(
    '[ACCESS CONTROL API] Load Access Control Contract Company Information Fail',
    props<{ error: any }>()
);

export const updateAccessControlContractCompanyInformation = createAction(
    '[ACCESS CONTROL SUBCONTRACTOR DETAILS COMPONENT] Update Access Control Contract Company Information',
    props<{ candidateId: number; formData: AccessControlContactInformation }>()
);

export const updateAccessControlContractCompanyInformationSuccess = createAction(
    '[ACCESS CONTROL API] Update Access Control Contract Company Information Success',
    props<{ candidateId: number }>()
);

export const updateAccessControlContractCompanyInformationFail = createAction(
    '[ACCESS CONTROL API] Update Access Control Contract Company Information Fail',
    props<{ error: any }>()
);

export const loadAccessControlClientInformation = createAction(
    '[ACCESS CONTROL SUBCONTRACTOR DETAILS COMPONENT] Load Access Control Client Information',
    props<{ candidateId: number }>()
);

export const loadAccessControlClientInformationSuccess = createAction(
    '[ACCESS CONTROL API] Load Access Control Client Information Success',
    props<{ clientInformation: AccessControlContactInformation }>()
);

export const loadAccessControlClientInformationFail = createAction(
    '[ACCESS CONTROL API] Load Access Control Client Information Fail',
    props<{ error: any }>()
);

export const updateAccessControlClientInformation = createAction(
    '[ACCESS CONTROL SUBCONTRACTOR DETAILS COMPONENT] Update Access Control Client Information',
    props<{ candidateId: number; formData: AccessControlContactInformation }>()
);

export const updateAccessControlClientInformationSuccess = createAction(
    '[ACCESS CONTROL API] Update Access Control Client Information Success',
    props<{ candidateId: number }>()
);

export const updateAccessControlClientInformationFail = createAction(
    '[ACCESS CONTROL API] Update Access Control Client Information Fail',
    props<{ error: any }>()
);

export const resetAccessControlInformation = createAction(
    '[ACCESS CONTROL SUBCONTRACTOR DETAILS COMPONENT] Reset Access Control Information'
);
